import React from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Flex, Text } from 'core/components';

export const OAuthControls = observer(
  ({ status = {}, onConnect, connectText, icon, loading = status.connecting, intent, inline }) => {
    const defaultText = status.needs_reauth || status.connected ? 'Reconnect' : 'Connect';

    return (
      <Flex
        flexDirection={inline ? 'row' : 'column'}
        gap={inline ? 1 : '4px'}
        alignItems={inline ? 'center' : 'flex-start'}
      >
        <Button
          small
          intent={intent || (status.needs_reauth ? 'warning' : 'primary')}
          icon={icon}
          loading={loading}
          disabled={loading}
          onClick={onConnect}
        >
          {connectText || defaultText}
        </Button>
        {status.authorizeUrl && (
          <Text small>
            Popup blocked.{' '}
            <a href={status.authorizeUrl} target="_blank" rel="noopener noreferrer">
              Open the sign-in page
            </a>
          </Text>
        )}
        {status.error && (
          <Text small color="danger">
            {status.error}
          </Text>
        )}
      </Flex>
    );
  }
);

export default inject('$mcpServers')(
  observer(({ $mcpServers, serverId, serverName, onConnect, connectText }) => (
    <OAuthControls
      status={$mcpServers.oauthStatusMap.get(serverId)}
      onConnect={onConnect || (() => $mcpServers.connectOAuth(serverId, { serverName }))}
      connectText={connectText}
    />
  ))
);
